import { Box, styled, Typography } from '@mui/material'

export const Wrapper = styled(Box)`
  display: flex;
  flex-direction: column;
  align-items: end;
  justify-content: center;
  height: 48px;
  padding: 0 4px;
  width: 100%;
`

export const Amount = styled(Typography)`
  margin-bottom: 4px;
  font-size: 13px;
  font-weight: 400;
  color: ${({ theme }) => theme.palette.custom.gray5};
  text-align: right;

  .highlight & {
    color: ${({ theme }) => theme.palette.custom.green1};
  }
`

export const Cost = styled(Typography)`
  font-size: 12px;
  font-weight: 400;
  color: ${({ theme }) => theme.palette.custom.red1};
  text-align: right;
`
